// @flow
import * as React from 'react'
import Lightbox from '../../Lightbox'
import type { Props as BaseProps, RenderProps } from '../SelectorButton'

type Props = BaseProps &
  RenderProps & {
    selectorShowed: boolean,
  }

const MobileSelector = ({
  selectorShowed,
  open,
  close,
  appearance,
  mobileTitle,
  renderButton,
  renderSelector,
}: Props) => {
  const params = {
    appearance,
    open,
    close,
  }

  return (
    <React.Fragment>
      {renderButton(params)}
      <Lightbox
        showed={selectorShowed}
        title={mobileTitle}
        render={() => renderSelector(params)}
        onClose={params.close}
        appearance={appearance}
      />
    </React.Fragment>
  )
}

export default MobileSelector
